import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import PublicLayout from '../../components/layout/PublicLayout';

const FAQScreen = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const faqs = [
    {
      question: "How do I register and log in?",
      answer: "Open the app and follow the registration steps. Enter your mobile number, verify with OTP, and set up your profile. For login, use your registered mobile number and OTP."
    },
    {
      question: "How do I verify my account with OTP?",
      answer: "Enter the OTP sent to your mobile number on the OTP Verification screen. If you don't receive it, you can request a resend."
    },
    {
      question: "How do I complete my profile?",
      answer: "Follow the checklist on the Complete Profile screen to add specializations, opening hours, consultation fees, location, profile picture, and more. Once all items are complete, your profile will be marked as complete."
    },
    {
      question: "How do I update my location?",
      answer: "Go to the Update Location screen, fill in your details, and tap \"Save Location\". You can also select an address from Google."
    },
    {
      question: "How can I manage my opening hours?",
      answer: "Navigate to the Manage Opening Hours screen. You can add, edit, or remove time slots for each day and select consultation types."
    },
    {
      question: "How do I manage my specializations?",
      answer: "Go to the Manage Services screen to select or update your areas of expertise. You can search, add, or remove services as needed."
    },
    {
      question: "How do I set or update my consultation fees?",
      answer: "Visit the Consultation Fee screen. Enable or disable consultation types, set fees and durations, and save your changes."
    },
    {
      question: "How do I view and manage my appointments?",
      answer: "Go to the Appointments tab to view upcoming, past, and appointment details. You can approve, reschedule, or complete appointments from here."
    },
    {
      question: "How do I start a video or audio call for a consultation?",
      answer: "Go to the appointment details and tap the \"Start Video Call\" or \"Start Audio Call\" button to connect with your client."
    },
    {
      question: "How do I view my earnings and transaction history?",
      answer: "Go to the Earnings screen to see your total earnings, monthly breakdown, and transaction history. You can also view all transactions in detail."
    },
    {
      question: "How do I contact support or get help?",
      answer: "Go to the Contact Us screen to send a message, call, or email support. Office details and working hours are also listed there."
    },
    {
      question: "How do I log out?",
      answer: "Go to the Profile tab and tap the \"Logout\" button to securely log out of your account."
    }
  ];

  const filteredFaqs = faqs.filter(faq => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return faq.question.toLowerCase().includes(query) || 
           faq.answer.toLowerCase().includes(query);
  });

  return (
    <PublicLayout title="Frequently Asked Questions">
      <div className="search-container">
        <FaSearch className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder="Search FAQs..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="faq-list">
        {filteredFaqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question">{faq.question}</div>
            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>

      {filteredFaqs.length === 0 && (
        <div className="no-results">
          <p>No FAQs found matching your search.</p>
        </div>
      )}
    </PublicLayout>
  );
};

export default FAQScreen;